import Services from './base-services'

const service = new Services('courseBook')

export default {
  getBookListByCourseAndDate(data: any) {
    return service.get(`getBookListByCourseAndDate?courseId=${data.userCourseId}&date=${data.bookDate}`)
  }
}
